/**
 * Remembers which units the visitor opened from the similar-places block under
 * a search, so the detail view, the reservation and the payment of such a unit
 * can be attributed to the block. Kept for the browser tab only: the round
 * trip to Stripe and back stays in the tab, a new visit starts clean.
 */
const STORAGE_KEY = 'mv_similar_units'

function readUnitIds(): number[] {
  try {
    const stored: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? '[]')
    return Array.isArray(stored) ? stored.filter((id): id is number => typeof id === 'number') : []
  } catch {
    return []
  }
}

export function rememberSimilarUnit(unitId: number): void {
  const unitIds = readUnitIds()
  if (unitIds.includes(unitId)) return
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...unitIds, unitId]))
  } catch {
    // Storage blocked: the visit just stays unattributed.
  }
}

/** 'similar' when the unit was opened from the similar-places block, otherwise undefined. */
export function offerSource(unitId: number | undefined): 'similar' | undefined {
  return unitId !== undefined && readUnitIds().includes(unitId) ? 'similar' : undefined
}
